import { Component, Output, EventEmitter, Input, Directive } from '@angular/core';

// import { Cell } from 'ng2-smart-table/lib/data-set/cell';
import { Cell } from 'ng2-smart-table';

@Directive()
export class DefaultEditorComponent implements Editor {
  @Input() cell: Cell;
  @Input() inputClass: string;

  @Output() onStopEditing = new EventEmitter<any>();
  @Output() onEdited = new EventEmitter<any>();
  @Output() onClick = new EventEmitter<any>();
}

export interface Editor {
  cell: Cell;
  inputClass: string;
  onStopEditing: EventEmitter<any>;
  onEdited: EventEmitter<any>;
  onClick: EventEmitter<any>;
}
